import React, { Component, Fragment } from "react";
import ReactDOM from "react-dom";

import { Table, message, Spin } from "antd";

//Component import
import ReportLayout from "../../../pageLayouts/Report";
import { fetchApi, fetchExcelApi } from "../../../../services/api";
import MultiTable from "../MultiTable3";
import Empty from "../../../components/Custom/Empty";

//Utility
import { sortFunction } from "../../../../utility/sorter";
import { mapKeys, isEmpty, cloneDeep } from "lodash";
import { parseData, parserFunction } from "./parserFunctions";
import { COOKIE, getCookie } from "../../../../services/cookie";

const columns = [
  {
    title: "Type",
    dataIndex: "type"
  },
  {
    title: "Seedling",
    dataIndex: "seedling",
    render: it => (it ? it : 0)
  },
  {
    title: "Plant",
    dataIndex: "plant",
    render: it => (it ? it : 0)
  },
  {
    title: "Tree",
    dataIndex: "tree",
    render: it => (it ? it : 0)
  }
];

class RowAreaWiseSummary extends Component {
  componentRef = React.createRef();
  state = {
    data: [],
    loading: false,
    farmTotal: [],
    blockNoList: [],
    block_uuid: null,
    blockNumber: null,

    areaNoList: [],
    area_uuid: null,
    areaNumber: null,

    rowNoList: [],
    row_uuid: null,
    rowNumber: null
  };

  componentDidMount() {
    this.fetchRowAreaWiseSummary();
    this.fetchBlockNo();
  }

  fetchRowAreaWiseSummary = () => {
    this.setState({ loading: true });
    let { block_uuid, area_uuid, row_uuid } = this.state;
    let url = "/tree-age/row-wise-summary";
    console.log(block_uuid, area_uuid, row_uuid);
    if (block_uuid && !area_uuid && !row_uuid)
      url += `?block.uuid=${block_uuid}`;
    else if (block_uuid && area_uuid && !row_uuid)
      url += `?block.uuid=${block_uuid}&area.uuid=${area_uuid}`;
    else if (block_uuid && area_uuid && row_uuid)
      url += `?block.uuid=${block_uuid}&area.uuid=${area_uuid}&row.uuid=${row_uuid}`;
    fetchApi(url, "get").then(res => {
      if (res) {
        if (res.blocks)
          this.setState(
            {
              data: parseData(cloneDeep(res.blocks)),
              farmTotal: res.farm_total
                ? parserFunction(cloneDeep([res.farm_total]), 1)
                : []
            },
            () => console.log(this.state.data)
          );
        else
          this.setState({
            data: null,
            farmTotal: []
          });
      } else message.error("Internal Server Error!");
      this.setState({ loading: false });
    });
  };

  fetchBlockNo = () =>
    fetchApi("/blocksuuid", "get").then(data =>
      this.setState({ blockNoList: sortFunction(data, "blockNoFull") })
    );

  generateTables = tableData =>
    tableData.map(({ areas, block_no, ...rest }, i) => (
      <div key={i}>
        {areas.map(({ area_no, rows, total }, areaIndex) => [
          rows.map(
            (
              { dwarfs, talls, pitGap, row_no, start_tree, end_tree, total },
              rowIndex
            ) =>
              pitGap ? (
                <MultiTable
                  pagebreak={
                    i == 0 && areaIndex == 0 && rowIndex == 0 ? "" : "pagebreak"
                  }
                  key={rowIndex}
                  dwarfs={dwarfs}
                  talls={talls}
                  pitGap={pitGap}
                  total={total}
                  columns={columns}
                  headerItems={[
                    { title: "Block No.", value: block_no },
                    { title: "Area No.", value: area_no },
                    { title: "Row No.", value: row_no },
                    { title: "Start Tree", value: start_tree },
                    { title: "End Tree", value: end_tree }
                  ]}
                />
              ) : null
          ),
          total.map(({ dwarfs, talls, pitGap }, totalIndex) =>
            pitGap ? (
              <MultiTable
                pagebreak="pagebreak"
                key={totalIndex}
                dwarfs={dwarfs}
                talls={talls}
                pitGap={pitGap}
                columns={columns}
                headerItems={[{ title: "Area Total", value: area_no }]}
              />
            ) : null
          )
        ])}
        {rest.total.map(({ dwarfs, talls, pitGap }, totalIndex) => (
          <MultiTable
            pagebreak="pagebreak"
            key={totalIndex}
            dwarfs={dwarfs}
            talls={talls}
            pitGap={pitGap}
            columns={columns}
            headerItems={[{ title: "Block Total", value: block_no }]}
          />
        ))}
      </div>
    ));

  onBlockChangeHandler = it => {
    let { blockNoList } = this.state;

    if (it) {
      fetchApi(
        `/areasuuid?block.uuid=${
          cloneDeep(blockNoList).filter(item => item.blockNoFull == it)[0].uuid
        }`,
        "get"
      ).then(res => this.setState({ areaNoList: res }));
    }

    this.setState(
      {
        blockNumber: it ? it : null,
        block_uuid: it
          ? cloneDeep(blockNoList).filter(each => each.blockNoFull === it)[0]
              .uuid
          : null,
        areaNumber: null,
        areaNoList: [],
        rowNumber: null,
        rowNoList: []
      },
      () => this.fetchRowAreaWiseSummary()
    );
  };

  onAreaChangeHandler = it => {
    let { areaNoList, blockNoList, blockNumber } = this.state;

    if (it) {
      fetchApi(
        `/rowsuuid?area.uuid=${
          cloneDeep(areaNoList).filter(item => item.areaNo == it)[0].uuid
        }&block.uuid=${
          cloneDeep(blockNoList).filter(
            item => item.blockNoFull == blockNumber
          )[0].uuid
        }`,
        "get"
      ).then(res => this.setState({ rowNoList: res }));
    }

    this.setState(
      {
        areaNumber: it ? it : null,
        area_uuid: it
          ? cloneDeep(areaNoList).filter(each => each.areaNo === it)[0].uuid
          : null,
        rowNumber: null,
        rowNoList: []
      },
      () => this.fetchRowAreaWiseSummary()
    );
  };

  onRowChangeHandler = it => {
    let { rowNoList } = this.state;

    this.setState(
      {
        rowNumber: it ? it : null,
        row_uuid: it
          ? cloneDeep(rowNoList).filter(each => each.rowNoFull === it)[0].uuid
          : null
      },
      () => this.fetchRowAreaWiseSummary()
    );
  };

  generateExcel = () => {
    let { block_uuid, area_uuid, row_uuid } = this.state,
      url = "/tree-age/row-wise-summary";

    if (block_uuid && !area_uuid && !row_uuid)
      url += `?block.uuid=${block_uuid}`;
    else if (block_uuid && area_uuid && !row_uuid)
      url += `?block.uuid=${block_uuid}&area.uuid=${area_uuid}`;
    else if (block_uuid && area_uuid && row_uuid)
      url += `?block.uuid=${block_uuid}&area.uuid=${area_uuid}&row.uuid=${row_uuid}`;

    fetchExcelApi(url, "get").then();
  };

  render() {
    let {
      data,
      loading,
      farmTotal,
      blockNumber,
      blockNoList,
      areaNumber,
      areaNoList,
      rowNumber,
      rowNoList
    } = this.state;
    let JSX =
      data && data.length > 0 ? (
        <Fragment>
          <h3>
            Row Wise/Area Wise Summary All Types Tree/Plant/Seedling/Pit/Gap
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Farm :{" "}
            {getCookie(COOKIE.FARM)
              .charAt(0)
              .toUpperCase() + getCookie(COOKIE.FARM).slice(1)}{" "}
          </h3>
          {this.generateTables(data)}
        </Fragment>
      ) : (
        <Empty description="No Data Found" />
      );
    console.log(farmTotal);
    const buttonList = data
      ? [
          {
            label: "Excel",
            icon: "file-text",
            onClickHandler: () => this.generateExcel()
          },
          {
            label: "Print",
            icon: "diff",
            //toolTip: "Suggestion: Print in Landscape",
            reference: this.componentRef
          }
        ]
      : null;
    return (
      <ReportLayout
        title="Row Wise/Area Wise Summary All Types Tree/Plant/Seedling/Pit/Gap"
        buttonList={buttonList}
        dropDownList={[
          {
            label: "Block",
            listItems: cloneDeep(blockNoList).map(it => it.blockNoFull),
            changeHandler: it => this.onBlockChangeHandler(it)
          },
          {
            label: "Area",
            listItems: cloneDeep(areaNoList).map(it => it.areaNo),
            disabled: blockNumber ? false : true,
            value: areaNumber ? areaNumber : undefined,
            changeHandler: it => this.onAreaChangeHandler(it)
          },
          {
            label: "Row",
            listItems: cloneDeep(rowNoList).map(it => it.rowNoFull),
            disabled: areaNumber ? false : true,
            value: rowNumber ? rowNumber : undefined,
            changeHandler: it => this.onRowChangeHandler(it)
          }
        ]}
      >
        <div ref={this.componentRef}>
          <Spin spinning={loading} size="large">
            {JSX}
            {farmTotal.map(({ dwarfs, talls, pitGap }, index) => (
              <MultiTable
                pagebreak="pagebreak"
                key={index}
                dwarfs={dwarfs}
                talls={talls}
                pitGap={pitGap}
                columns={columns}
                headerItems={[{ title: "Farm total", value: null }]}
              />
            ))}
          </Spin>
        </div>
      </ReportLayout>
    );
  }
}

export default RowAreaWiseSummary;
